import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { descMaxLength, nameMaxLength } from '../../../Constant.js'
import axios from 'axios'
import ImageCropper from '../../../common/ImageCropper/ImageCropper.js'
import GroupCheckbox from '../../../common/GroupCheckbox/GroupCheckbox.js'

class CarAdd extends React.Component {
  state = {
    is_active: 'true',
    name_en: '',
    name_ar: '',
    img_url_en: '',
    img_url_ar: '',
    description_en: '',
    description_ar: '',
    company_id: '',
    categoryList: [],
    car_categories: [],
    isSaving: false,
    isData: false,
    Edit: false,
    companyEditAr: false,
  }

  componentDidMount() {
    if (this.props?.id) {
      this.getCarDetails()
    }
    this.getCategoryList()
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleCategoryChange = (event) => {
    this.setState({ car_categories: event })
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })
  }

  getCategoryList = () => {
    axios
      .get(Constant.getAPI() + `/car/list-car-category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const catData = res.data?.data?.filter((ele) => ele.is_active == true)
          this.setState({
            categoryList: catData,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSave = () => {
    var that = this
    const formData = new FormData()
    formData.append('name_en', this.state.name_en)
    formData.append('company_id', this.props.company_id)
    formData.append('car_categories', this.state.car_categories)
    formData.append('name_ar', this.state.name_ar)
    formData.append('description_en', this.state.description_en)
    formData.append('description_ar', this.state.description_ar)
    formData.append('is_active', this.state.is_active)

    if (this.props.id) {
      that.setState({ isData: true })
      formData.append('id', this.props.id)
      if (this.state.img_url_en?.type) {
        formData.append('img_url_en', this.state.img_url_en, 'your_original_filename.jpeg')
      }
      if (this.state.img_url_ar?.type) {
        formData.append('img_url_ar', this.state.img_url_ar, 'your_original_filename.jpeg')
      }
      axios
        .put(Constant.getAPI() + '/car/update-car', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Car has been Updated`, 'success')
            window.location.href = `#/car/${this.props?.company_id}`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      that.setState({ isData: true })
      if (this.state.img_url_en?.type) {
        formData.append('img_url_en', this.state.img_url_en, 'your_original_filename.jpeg')
      }
      if (this.state.img_url_ar?.type) {
        formData.append('img_url_ar', this.state.img_url_ar, 'your_original_filename.jpeg')
      }
      axios
        .post(Constant.getAPI() + '/car/create-car', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Car has been Added`, 'success')
            window.location.href = `#/car/${this.props?.company_id}`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  getCarDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/car/get-car/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          const selectedCategories = res?.data?.data?.car_links?.map((ele) => ele.category_id)
          this.setState({
            ...res?.data?.data,
            car_categories: selectedCategories,
            Edit: true,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Car Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    id="name_en"
                    placeholder=" Car Name: English"
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.name_en ? this.state.name_en.length + ' / ' + nameMaxLength : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Car Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder="Car Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.name_ar ? this.state.name_ar.length + ' / ' + nameMaxLength : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Car Description: English</label>
                <div className="col-sm-9">
                  <textarea
                    rows={4}
                    className="form-control"
                    name="description_en"
                    id="description_en"
                    placeholder="Car Description: English"
                    value={this.state.description_en}
                    onChange={this.handleChange}
                  />
                  <div className="col-sm-12 text-right">
                    {this.state.description_en
                      ? this.state.description_en.length + ' / ' + descMaxLength
                      : 0 + ' / ' + descMaxLength}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Car Description: Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    rows={4}
                    className="form-control"
                    name="description_ar"
                    id="description_ar"
                    placeholder="Car Description: Arabic"
                    value={this.state.description_ar}
                    onChange={this.handleChange}
                  />
                  <div className="col-sm-12 text-right">
                    {this.state.description_ar
                      ? this.state.description_ar.length + ' / ' + descMaxLength
                      : 0 + ' / ' + descMaxLength}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-12">
              <GroupCheckbox
                title={'Category'}
                list={this.state.categoryList}
                displayKey={'name_en'}
                idKey={'id'}
                selected={this.state.car_categories}
                onChange={(event) => this.handleCategoryChange(event)}
              ></GroupCheckbox>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option
                      value="true"
                      name=""
                    >
                      Active
                    </option>
                    <option
                      value="false"
                      name=""
                    >
                      Inactive
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <ImageCropper
                        ratio={1 / 1}
                        img={this.state.img_url_en || null}
                        onChange={(e) => {
                          this.handleChangeImage(e, 'img_url_en')
                        }}
                      ></ImageCropper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: Arabic</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <ImageCropper
                        ratio={1 / 1}
                        img={this.state.img_url_ar || null}
                        onChange={(e) => {
                          this.handleChangeImage(e, 'img_url_ar')
                        }}
                      ></ImageCropper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSave}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}

            <Link
              to={`/car/${this.state.company_id}`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default CarAdd
